import { Form } from 'components';
import React, { useCallback } from 'react';
import { usePurchaseOrderCreateMutation } from 'api';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { useNavigate } from 'react-router-dom';
import { ADMIN_ROUTES } from 'constants/routes';

export const useChooseSupplierModal = (props: {
  onModalStateChange: (value: boolean) => void;
  purchaseOrderItemIds: React.Key[];
}) => {
  const { onModalStateChange, purchaseOrderItemIds } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [createPurchaseOrder, { isLoading }] = usePurchaseOrderCreateMutation();

  const { handleError, handleSuccess } = useNotificationMessages();

  const onCancel = useCallback(() => {
    form.resetFields();
    onModalStateChange(false);
  }, [form, onModalStateChange]);

  const onFinish = useCallback(
    async (values: any) => {
      const payload = values;
      payload.purchaseOrderItemIds = purchaseOrderItemIds.flat();
      try {
        const { data, error } = await createPurchaseOrder(payload);
        if (data?.success) {
          handleSuccess(`The Purchase Order was successfully created`);
          navigate(`${ADMIN_ROUTES.purchaseOrder.view}/${data.data}/general`);
          onCancel();
        } else {
          handleError(error);
        }
      } catch (err) {
        handleError(err);
      }
    },
    [createPurchaseOrder, onCancel, handleSuccess, handleError, purchaseOrderItemIds, navigate]
  );

  return {
    form,
    onCancel,
    onFinish,
    isLoading,
  };
};
